import { render, staticRenderFns } from "./redirectPage.vue?vue&type=template&id=4a22390d&scoped=true&"
import script from "./redirectPage.vue?vue&type=script&lang=js&"
export * from "./redirectPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a22390d",
  null
  
)

export default component.exports